import React, { useCallback } from 'react'
import styled from 'styled-components'
import clsx from 'clsx'
import { rem } from 'polished'
import { useIntl } from 'react-intl'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import LineAngleRightIcon from 'LuxKit/Icons/line/LineAngleRightIcon'
import DropdownChevron from 'LuxKit/Dropdown/DropdownChevron'
import { getNavigationMenuIcon } from 'content/components/Icon/utils'

const NewBadge = styled.span`
  margin-left: ${rem(8)};
  background-color: ${props => props.theme.palette.highlight.secondary.lightBackground};
  color: ${props => props.theme.palette.highlight.secondary.normalForeground};
  padding: 0 ${rem(2)};
  border-radius: ${props => props.theme.borderRadius.S};
  font-weight: ${props => props.theme.font.primary.weight.bold};
  /* This has not been designed to match LuxKit yet, and needs specific values */
  font-size: 10px;
  line-height: 13px;
  vertical-align: text-top;

`

interface Props extends Omit<React.HTMLAttributes<HTMLElement>, 'onClick'> {
  navItem: App.NavItem
  onClick?: (navItem: App.NavItem) => void
  isOpen?: boolean
}

function NavigationMenuItem(props: Props) {
  const { className, navItem, isOpen, onClick, ...rest } = props
  const intl = useIntl()
  const iconName = navItem.sideNavIconName || navItem.iconName
  const Icon = iconName && getNavigationMenuIcon(iconName)
  const onNavClick = useCallback(() => {
    onClick?.(navItem)
  }, [navItem, onClick])

  const newLabelText = intl.formatMessage({
    id: 'gFHP2UfB3M',
    defaultMessage: 'NEW',
    description: 'New badge label for navigation items',
  })

  return (
    <ClickableListItem
      {...rest}
      title={<div>
        {navItem.text}{navItem.newLabel && <NewBadge>{newLabelText}</NewBadge>}
      </div>}
      role="menuitem"
      startIcon={Icon && <Icon size="M" />}
      className={clsx(className, navItem.linkClass)}
      to={navItem.to}
      href={navItem.href}
      target={navItem.target}
      onClick={onNavClick}
      endIcon={navItem.items?.length ? <DropdownChevron open={isOpen} /> : <LineAngleRightIcon />}
    />
  )
}

export default NavigationMenuItem
